import React, { useEffect, lazy, memo } from 'react';
import { CheckCircleIcon, ClockIcon } from 'lucide-react';
import { trackPurchaseClick, trackLeadEvent } from './MetaPixel';
const HowItWorks = () => {
  const handleCTAClick = () => {
    trackPurchaseClick('how_it_works_section');
    window.location.href = 'https://shopysv.com/products/pide-tu-gorro-anti-migrana';
  };
  // Rastrear cuando el usuario ve los beneficios
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          trackLeadEvent('viewed_how_it_works');
          observer.disconnect();
        }
      });
    }, {
      threshold: 0.5
    });
    const section = document.getElementById('how-it-works');
    if (section) {
      observer.observe(section);
    }
    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);
  return <section id="how-it-works" className="py-16 md:py-24 bg-[#f8f9ff]" data-id="element-218">
      <div className="container mx-auto px-4 md:px-6" data-id="element-219">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-220">
          <div className="md:w-1/2" data-id="element-221">
            <div className="relative" data-id="element-222">
              <div className="absolute -inset-1 bg-gradient-to-r from-[#8b5cf6] to-[#4ade80] rounded-2xl blur opacity-20" data-id="element-223"></div>
              <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden p-1" data-id="element-224">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m4cYenXFttBhuGpiyEiict/ChatGPT_Image_8_sept_2025%2C_10_15_26_a.m..png" alt="Corona de Alivio 360 en uso - Máscara púrpura con tecnología de frío/calor" className="w-full h-auto rounded-xl" width="600" height="400" loading="lazy" data-id="element-225" />
              </div>
            </div>
          </div>
          <div className="md:w-1/2" data-id="element-226">
            <h2 className="text-3xl md:text-4xl font-bold mb-8 text-[#1e293b]" data-id="element-227">
              Rutina Terapéutica Inteligente
            </h2>
            <div className="space-y-6" data-id="element-228">
              <p className="text-lg text-[#4a5568]" data-id="element-229">
                Este dispositivo interrumpe ese ciclo silencioso. Usa tecnología
                terapéutica validada clínicamente para iniciar el alivio tras 15
                minutos de uso rutinario.
              </p>
              <div className="mt-6 p-4 bg-[#f0f4ff] rounded-lg border border-[#dbeafe]" data-id="element-230">
                <h3 className="text-lg font-medium text-[#1e293b] mb-2" data-id="element-231">
                  Puedes usarlo frío o caliente:
                </h3>
                <ul className="space-y-2 text-[#4a5568]" data-id="element-232">
                  <li className="flex items-center" data-id="element-233">
                    <ClockIcon size={18} className="text-[#6366f1] mr-2" data-id="element-234" />
                    <span data-id="element-235">Frío: 10 a 15 minutos</span>
                  </li>
                  <li className="flex items-center" data-id="element-236">
                    <ClockIcon size={18} className="text-[#6366f1] mr-2" data-id="element-237" />
                    <span data-id="element-238">Calor: hasta 10 minutos</span>
                  </li>
                  <li data-id="element-239">• Ajusta según tu tolerancia y necesidad</li>
                </ul>
              </div>
              <p className="text-lg text-[#4a5568]" data-id="element-240">
                Sin pastillas. Sin efectos secundarios. Sin fricción.
              </p>
              <div className="mt-8 space-y-4" data-id="element-241">
                <h3 className="text-2xl font-semibold text-[#1e293b]" data-id="element-242">
                  Piensa lo que podrías lograr con 40 horas más al mes:
                </h3>
                <div className="flex items-start" data-id="element-243">
                  <CheckCircleIcon size={24} className="text-[#4ade80] mt-1 mr-3 shrink-0" data-id="element-244" />
                  <p className="text-lg text-[#4a5568]" data-id="element-245">
                    Sin pausas. Sin excusas. Sin dolor.
                  </p>
                </div>
                <div className="flex items-start" data-id="element-246">
                  <CheckCircleIcon size={24} className="text-[#4ade80] mt-1 mr-3 shrink-0" data-id="element-247" />
                  <p className="text-lg text-[#4a5568]" data-id="element-248">Tu energía regresa.</p>
                </div>
                <div className="flex items-start" data-id="element-249">
                  <CheckCircleIcon size={24} className="text-[#4ade80] mt-1 mr-3 shrink-0" data-id="element-250" />
                  <p className="text-lg text-[#4a5568]" data-id="element-251">
                    Tus proyectos avanzan.
                  </p>
                </div>
                <div className="flex items-start" data-id="element-252">
                  <CheckCircleIcon size={24} className="text-[#4ade80] mt-1 mr-3 shrink-0" data-id="element-253" />
                  <p className="text-lg text-[#4a5568]" data-id="element-254">
                    Y tu vida ya no se negocia con el sufrimiento.
                  </p>
                </div>
              </div>
              <p className="text-lg text-[#4a5568] italic mt-6" data-id="element-255">
                🌱 Tu nueva normalidad empieza con una decisión.
              </p>
              <div className="mt-8" data-id="element-256">
                <button className="bg-[#8b5cf6] hover:bg-[#7c3aed] text-white px-8 py-4 rounded-full text-lg font-medium transition-all transform hover:scale-105 shadow-lg" onClick={handleCTAClick} data-id="element-257">
                  Quiero mi rutina de alivio ahora
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default memo(HowItWorks);